import templateUrl from './form.html'
import { tmrAdminUserFormController } from 'tmr/routes/admin/users/form'

/**
 * Edit own User route
 *
 * @namespace routes.AdminSelfFormEdit
 * @type {TmrRoute}
 */
export const route = {
  name: 'admin.self.list.edit',
  url: '/edit',
  label: 'ADMIN.SELF.EDIT',
  component: 'tmrSelfUserForm',
  resourceType: 'User',
  accessControl: [
    'Resource.edit',
    'Resource.SelfUser.list',
    'Resource.SelfUser.edit',
  ],
}

/**
 * Own user add/edit form component.
 *
 * @type {ngComponent}
 */
export const tmrSelfUserForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrSelfUserControllerForm',
  bindings: {
    toast: '<',
    loggedUser: '<',
  },
}

/**
 * Controller of component {@link tmrSelfUserForm}.
 *
 * @type {ngController}
 */
export class tmrSelfUserControllerForm extends tmrAdminUserFormController {
  static ngType = 'controller'

  constructor(
    $scope,
    $state,
    $stateParams,
    TmrInvalidFormError,
    TmrToast,
    $filter,
    $locale,
    TmrApiAuth,
    Place,
    tmrUserDateFormats,
    tmrLanguages,
    User
  ) {
    'ngInject'
    super(
      $scope,
      $state,
      $stateParams,
      TmrInvalidFormError,
      TmrToast,
      $filter,
      $locale,
      TmrApiAuth,
      Place,
      tmrUserDateFormats,
      tmrLanguages
    )
    Object.assign(this, { User })
  }

  /** @override */
  $onInit() {
    this.resource = this.loggedUser
    super.$onInit()
  }

  /** @override */
  save() {
    this.User.updateSelf(this.resource)
    return this.TmrApiAuth.updateLoggedUser(null, this.$state.current, {
      place: this.resource.place,
      submitAndContinue: true,
    })
  }

  /** @override */
  onUserSaved(destination, params) {
    return this.TmrApiAuth.updateLoggedUser(null, destination, params).then(
      this.TmrToast.success('ADMIN.SELF.UPDATE.SUCCESS', 'messageformat')
    )
  }
}
